// AUTO-GENERATED by scripts/gen-version.mjs — do not edit by hand.
export const APP_VERSION = "0.9.10d" as const;
export const COMMIT_SHA = "50c2682" as const;
export const BUILD_TIME = "2026-11-04T14:22:01.790Z" as const;
